import { useTheme } from "@hooks";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    exclusive: {
      color: theme.exclusive.default,
      border: `1px solid ${theme.exclusive.default}`,
      fontSize: 12,
      fontWeight: 600,
      borderRadius: 4,
      padding: 2,
      display: "flex",
      flexShrink: 0,
      flex: 0,
    },
  };

  return styles;
};
